/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { StoreModule } from '@ngrx/store';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { ChartService } from './services/dashboard/chart.service';
import { StallsService } from './services/stalls.service';
import { stallReducer, configBillsReducer } from './ngrx-store/reducer';
import { AuthenticateService } from './services/authenticate.service';
import { AuthModule } from './components/auth/auth.module';
import { SigninService } from './services/signin.service';
import { JWTService } from './services/JWT.service';
import { GuestGuard } from './guards/auth.guard';
import { CkeditorService } from './services/ckeditor.service';
import { BillDetailsService } from './services/configuration/bill-details.service';
import { CustomizedColorService } from './services/configuration/customized-color.service';
import { LogoService } from './services/configuration/logo.service';
import { ToastrService } from './services/Toastr/toastr.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    AuthModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    StoreModule.forRoot({
      stalls: stallReducer,
      configbills: configBillsReducer,
    }),
  ],
  providers: [
    ChartService,
    StallsService,
    AuthenticateService,
    SigninService,
    JWTService,
    GuestGuard,
    CkeditorService,
    BillDetailsService,
    CustomizedColorService,
    LogoService,
    ToastrService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
